export default __webpack_public_path__ + "static/media/banner_desk_amarelo_1.be3ff808.jpg";